import { useEffect, useLayoutEffect, useRef } from "react";
import { isProd } from "common/src/Env.bind";
import { useRouter } from "next/router";

export default function NitroBotAnchor(_props) {
  const el = useRef(null);
  const id = "na-bot-anchor";
  const router = useRouter();
  const adUnit = useRef(null);

  if (typeof window !== "undefined") {
    useLayoutEffect(() => {
      el.current.id = id;
    }, [id]);
  }

  useEffect(() => {
    if (window.afm) {
      return;
    }

    adUnit.current = window["nitroAds"]?.createAd("na-bot-anchor", {
      refreshTime: 30,
      format: "anchor-v2",
      anchor: "bottom",
      anchorPersistClose: true,
      demo: !isProd,
      // anchorBgColor: "var(--primary-2)",
      anchorBgColor: "transparent",
      report: {
        enabled: true,
        icon: true,
        wording: "Report Ad",
        position: "top-right",
      },
      mediaQuery:
        "(min-width: 1025px), (min-width: 768px) and (max-width: 1024px), (min-width: 320px) and (max-width: 767px)",
    });
  }, [id]);

  useEffect(() => {
    if (!window.afm && adUnit.current != null) {
      if (adUnit.current.then) {
        adUnit.current.then((adUnit) => {
          adUnit.onNavigate();
        });
      } else if (adUnit.current.onNavigate) {
        adUnit.current.onNavigate();
      }
    }
  }, [router.asPath]);

  return (
    <div
      ref={(ref) => (el.current = ref)}
      key={id}
      id={id}
      dangerouslySetInnerHTML={{ __html: "" }}
      suppressHydrationWarning
    />
  );
}
